// extracted by mini-css-extract-plugin
export default {"top":"Estimates_top__rFDT-","box":"Estimates_box__wmzHq","addButton":"Estimates_addButton__r+j0H"};